<template>
  <div class="popup popup--md active">
    <div class="popup__wrap">
      <div class="popup__box">
        <div class="popup__head">
          <div class="popup__title">
            <!-- 기관별 평가현황 -> 배분현황 클릭해서 들어오는 팝업 -->
            <p>평가원 기관별 평가권한 배분하기</p>
          </div>
          <button type="button" class="popup__close icon-only icon-x" @click="popupClose"></button>
        </div>
        <div class="popup__body">

            <div class="table__wrap spacing--xxxs">
            <table class="table table--split" style="min-width:768px;">
              <tr>
                <th>
                  <input type="checkbox" id="check_all1" @change="toggleAll2($event.target.checked)" v-model="isAllChecked2">
                  <label for="check_all1"></label>
                </th>
               
                <th>기관명</th>
              </tr>
              <tr v-for="(vo, index) of orgList" :key="index" >
                <td>
                  <input type="checkbox" :id="'check1_' + index" v-model="checkedItems2[index]">
                  <label :for="'check1_' + index"></label>
                </td>

                <td>{{vo.organizationName}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="popup__btns">
          <button type="button" class="btn btn--sm btn--basic icon-check" @click="popupClose">닫기</button>
          <button type="button" class="btn btn--sm btn--primary icon-check" @click="goSave">
            등록
          </button>
        </div>
      </div>
      <div class="popup__bg"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted ,watch} from "vue";
import { useStore } from "vuex";
import { insertPermissions,selectPermissions } from '@/api/eval'

const store = useStore();

//const selectedMember = computed(() => store.state.member.member  || [] )
const selectedCode = computed(() => store.state.member.orgCode  || [] )
//evalUsetData  setEvalUsetData  clearEvalUsetData
const userOptions = ref([]); // 콤보박스 리스트

const searchText = ref('')
const searchCode = ref('all')

const checkUserId = computed(() => store.state.temp.userInfo )

const orgList = computed(() => {
	return store.state.grid.orgData
})

const searchParam = computed(() => {
	return store.state.temp.searchParam 
})

const checkedItems2 = ref(orgList.value.map(() => false));
const isAllChecked2 = ref(false); // 전체선택 상태

const toggleAll2 = (checked) => {
  checkedItems2.value = checkedItems2.value.map(() => checked);
};


watch(checkedItems2, (newVal) => {
  isAllChecked2.value = newVal.length > 0 && newVal.every(Boolean);
}, { deep: true });


watch(orgList, (newVal) => {
  checkedItems2.value = newVal.map(() => false);
});

const goSave = async () => {
    // 체크된 항목들의 vo.no를 객체 배열로 저장
    const selectedOrgs = orgList.value
        .filter((notice, index) => checkedItems2.value[index])
        .map((selectedMember) => ({ 
          organizationCode: selectedMember.organizationCode,
          memberCode : selectedCode.value,
          adminCode : checkUserId.value.memberCode
         }));

    // 배열에 저장된 객체 배열을 콘솔에 출력
    console.log('Selected Notice Objects:', selectedOrgs);

    //여기서 deleteNotice API 호출
    if (confirm("해당 평가자에게 권한을 부여하시겠습니까?")) {
        let rtn = await insertPermissions(selectedOrgs); // 객체 배열을 그대로 전달
        console.log("선택된 평가원 목록:", selectedOrgs);
        
        if (rtn.result == 'ok') {
            alert(rtn.resultMsg);
            popupClose()
        } else { 
            alert(rtn.resultMsg);
        }
    }
};



// 저장할때 memberCode를 memberName으로 변경
const getUserNameByCode = (code) => {
  const user = userOptions.value.find(u => u.value === code);
  return user ? user.label : code;
};


// 데이터 초기화 (API 호출로 대체 가능)
const getGridData = async () => {
  let param = {
		pageNo : 1,
		countPerRecord : 1000,
		search : searchText.value,
		typeCd : searchCode.value
	}
	console.log()
	await store.dispatch('grid/fetchOrgVue', param)
};

const evalList = ref([]) // 메인 그리드 조회

const getEvalData = async () => {
  let param = {
		memberCode : selectedCode.value
	}
	const rtn = await selectPermissions(param);

  if (rtn?.result === 'ok' && Array.isArray(rtn.data)) {
      // 그대로 table에 바인딩
      evalList.value = rtn.data.map(item => ({
        organizationCode: item.organizationCode
      }));
      checkedItems2.value = orgList.value.map(org =>
      evalList.value.some(e => e.organizationCode === org.organizationCode)
    );
    } else {
      evalList.value = [];
      checkedItems2.value = orgList.value.map(() => false);
    }
};


onMounted(async() => {
	//console.log("부모창에서 받은 팝업 데이터 : " + selectedMember.value)
  console.log("부모창에서 받은 팝업 데이터2 : " + selectedCode.value)
  console.log("111" + checkUserId.value.memberCode)
	await getGridData(); // 도메인 항목과 스탠다드 항목을 전부 가져옴
  await getEvalData()

});

const popupClose = () => {
  store.commit("temp/setIsOrgEvalDist");
};
</script>

<style scoped>

/* ========================= */
/* ✅ 공통 콤보박스 스타일 */
/* ========================= */
.combo-box {
  margin-left: 10px; /* 왼쪽 여백 */
  padding: 2px 4px; /* 내부 여백 */
  font-size: 12.6px; /* 글자 크기 (10% 축소) */
  font-weight: normal; /* 볼드체 제거 */
  height: 28px; /* 높이 */
  width: 75px; /* 가로 너비 (10% 증가) */
  border: 1px solid #ccc; /* 테두리 색상 */
  border-radius: 4px; /* 모서리 둥글게 */
  background-color: #fff; /* 배경색 */
  cursor: pointer; /* 포인터 커서 */
  appearance: none; /* 브라우저 기본 스타일 제거 */
  -webkit-appearance: none;
  -moz-appearance: none;

  /* 화살표 아이콘 추가 */
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat; /* 화살표 반복 방지 */
  background-position: right 8px center; /* 화살표 위치 */
  background-size: 12px; /* 화살표 크기 */
}

/* ✅ 콤보박스 포커스 스타일 */
.combo-box:focus {
  border-color: #009FDE; /* 포커스 시 테두리 색상 */
  outline: none; /* 포커스 아웃라인 제거 */
  box-shadow: 0 0 5px rgba(0, 159, 222, 0.5); /* 포커스 시 그림자 */
}

/* ✅ 도메인 콤보박스 스타일 */
.domain-title .combo-box {
  margin-left: auto; /* 왼쪽 자동 여백 */
  margin-right: 5px; /* 오른쪽 여백 */
}

/* ✅ 스탠다드 콤보박스 스타일 */
.standard-item .combo-box {
  margin-left: 10px; /* 왼쪽 여백 */
  font-size: 12.6px; /* 글자 크기 */
  font-weight: normal; /* 볼드체 제거 */
  padding: 2px 4px; /* 내부 여백 */
  height: 28px; /* 높이 */
  width: 75px; /* 가로 너비 */
}

/* ========================= */
/* ✅ 도메인 스타일 */
/* ========================= */
.domain {
  border: 1px solid #ddd; /* 테두리 */
  border-radius: 5px; /* 모서리 둥글게 */
  padding: 10px; /* 내부 여백 */
  margin-bottom: 10px; /* 아래 여백 */
  background-color: #f9f9f9; /* 배경색 */
  cursor: pointer; /* 커서 포인터 */
}

/* ✅ 선택된 도메인 스타일 */
.domain.selected {
  background-color: #009FDE; /* 파란색 배경 */
  color: #fff; /* 글자색 */
}

/* ✅ 도메인 타이틀 */
.domain-title {
  font-size: 14px; /* 글자 크기 */
  font-weight: normal; /* 볼드체 제거 */
  margin-bottom: 5px; /* 아래 여백 */
  display: flex; /* 플렉스 박스 */
  justify-content: flex-start; /* 왼쪽 정렬 */
  align-items: center; /* 수직 정렬 */
  gap: 8px; /* 요소 간격 */
}

/* ✅ 도메인 제목과 화살표 간격 */
.domain-title-text {
  margin-right: 8px; /* 제목과 화살표 사이 간격 */
  flex: 1; /* 제목이 남은 공간을 차지하도록 설정 */
  text-align: left; /* 텍스트 왼쪽 정렬 */
}

/* ✅ 펼침/닫힘 버튼 스타일 */
.domain-toggle {
  font-size: 14px; /* 글자 크기 */
  cursor: pointer; /* 커서 포인터 */
}

/* ✅ 도메인 Hover 효과 */
.domain-title:hover {
  border-radius: 5px;
}

/* ========================= */
/* ✅ 스탠다드 스타일 */
/* ========================= */
.standard-list {
  padding-left: 24px; /* 스탠다드 항목의 들여쓰기 */
  margin-top: 5px; /* 위 여백 */
}

.standard-item {
  display: flex;
  align-items: center; /* 수직 정렬 */
  font-size: 14px;
  padding: 5px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
  margin-left: -6px; /* 도메인과 같은 들여쓰기 */
}

/* ✅ 선택된 스탠다드 항목 */
.standard-item.selected {
  background-color: #009FDE; /* 활성화된 스탠다드 배경색 */
  color: #fff; /* 글자색 */
}

/* ✅ 매핑된 스탠다드 항목 */
.standard-item.mapped {
  background-color: #009FDE; /* 매핑된 스탠다드 배경색 */
  color: #fff; /* 글자색 */
}

/* ✅ 스탠다드 콤보박스 */
.standard-item .combo-box {
  margin-left: auto; /* 콤보박스를 오른쪽으로 이동 */
  font-size: 12px;
  padding: 2px 6px;
  height: 28px;
  width: 75px;
}

/* ========================= */
/* ✅ 버튼 스타일 */
/* ========================= */
.popup__btns .btn:disabled {
  background: #ddd; /* 비활성화 버튼 배경 */
  color: #aaa; /* 비활성화 버튼 글자색 */
  cursor: not-allowed; /* 비활성화 커서 */
}

/* ========================= */
/* ✅ 팝업 배경 스타일 */
/* ========================= */
.popup__bg {
  background-color: rgba(0, 0, 0, 0.3); /* 어두운 배경 */
}

</style>
